import axiosApi, { setHeader } from "api/root.api";

export const useMaterialLib = async (token, assetId, projectId, modelId) => {
  const urlEnd = `/editor/asset/v1/${assetId}/to/${projectId}/${modelId}`;
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.post(urlEnd, {});
  const result = response.data;
  return result;
};
